import React, { useContext } from "react";
import { useUserContext } from "./useUserContext";

type MAIN_TYPE = ReturnType<typeof useUserContext>;

const USER_CONTEXT_INSTANCE: React.Context<MAIN_TYPE | undefined> = React.createContext<
    MAIN_TYPE | undefined
>(undefined);

export const UserContext = USER_CONTEXT_INSTANCE;
export const UserContextProvider = USER_CONTEXT_INSTANCE.Provider;

export function customUseUserContext<T>(Context: React.Context<T | undefined>): T | undefined {
    return useContext(Context);
}
